import React from 'react';
import ControlledExpansionPanels from '../../../../components/ControlledExpansionPanels/ControlledExpansionPanels';
import GetRequirementsDetails from '../../../../utils/helper';

const StaticDisplayRequirements = () => {

    return (
        <div style={{
            paddingBottom: 10, width: '90%',
            marginLeft: '4%'
        }}>
            <ControlledExpansionPanels title="BSc Programme Requirements"
                summary={GetRequirementsDetails(1)}
            />
            <ControlledExpansionPanels title="BSc Business Administration Requirements"
                summary={GetRequirementsDetails(2)}
            />
            <ControlledExpansionPanels title="LLB Programme Requirements"
                summary={GetRequirementsDetails(3)}
            />
            <ControlledExpansionPanels title="CertHE Social Sciences Entrance Requirements"
                summary={GetRequirementsDetails(4)}
            />
            <ControlledExpansionPanels title="CertHE Common Law"
                summary={GetRequirementsDetails(5)}
            />
            <ControlledExpansionPanels title="International Foundation Programme Requirements"
                summary={GetRequirementsDetails(6)}
            />
            <ControlledExpansionPanels title="English Language Requirements"
                summary={GetRequirementsDetails(7)}
            />
        </div >
    );
}

export default StaticDisplayRequirements;